import React, { memo, useCallback, PropsWithChildren } from "react";
import { List, Icon } from "semantic-ui-react";
import { IFileObj, EUploadStatus } from "../models/IFile";
import SgFileUpload, { IFileUploadElementProps } from "./FileUpload";
import FileView from './File'

export interface FileInputProps {
    name?: string;
    files: { id: string; name: string }[]
    multiple?: boolean;
    onUploaded?: (newFiles: { id: string; name: string }[]) => void;
    onRemoved: (guid: string) => void;
    onInvalidFile?: (error: Error) => void;
    inputAreaElem: React.ComponentType<PropsWithChildren<IFileUploadElementProps>>;
}


const noop = () => undefined;

const FileIndicator: React.FC<{ file: IFileObj; onRemove: any }> = ({ file, onRemove }) => {

    const loading = [EUploadStatus.Uploading, EUploadStatus.Removing].includes(file.status)
    const complete = file.status === EUploadStatus.Done;
    const error = [EUploadStatus.RemoveError, EUploadStatus.UploadError].includes(file.status)

    let ItemIcon
    if (loading) {
        ItemIcon = <Icon name="spinner" loading />
    } else if (complete || error) {
        ItemIcon = <Icon name="paperclip" size="small" />
    }

    const name = file.name || "";
    let shortTitle = name.length > 40 ? `${name.substr(0, 40)}...` : name;

    return (
        <List.Item>
            {ItemIcon && <List.Icon> {ItemIcon} </List.Icon>}
            <List.Content>
                <List.Header>
                    {file.name && file.guid && <FileView id={file.guid} title={shortTitle} />}
                    {<span style={{ padding: '10px 0', fontWeight: 'lighter', fontSize: '0.9em' }}> ({file.status})</span>}
                    <span onClick={() => onRemove(file)} style={{ marginLeft: '20px', cursor: 'pointer', color: 'grey' }}>
                        <Icon name="times" />
                    </span>
                </List.Header>
            </List.Content>
        </List.Item>
    );
};

const ListWrapper: React.FC = ({ children }) => (<List> {children} </List>)

const FileInput: React.FC<FileInputProps> = (props) => {
    const {
        onUploaded = noop,
        onRemoved = noop,
        inputAreaElem,
        multiple,
        files,
        name
    } = props;

    const onUploadedCallback = useCallback((files: { id: string; name: string }[]) => {
        onUploaded(files);
    }, [onUploaded]);

    return (
        <SgFileUpload
            name={name}
            accept={undefined}
            multiple={multiple}
            onUploaded={onUploadedCallback}
            onRemoved={onRemoved}

            wrapElement={inputAreaElem}
            loaderElement={FileIndicator}
            listWrapperElement={ListWrapper}
            files={files}
        />
    );
};

export default memo(FileInput);
